import React from 'react';
import Page from "../Page";
import EmailList from "./emails/EmailList";

const Emails = () => {
    return (
        <Page>
            <EmailList />
        </Page>
    );
};

export default Emails;